import { ControlDataTypeKey } from "./control-data-type-key";
const TextAreaControlDataTypeKey = ControlDataTypeKey;
const TextAreaControlDataTypeValueV1 = "text-area::v1";
const TextAreaControlType = "makeswift::controls::text-area";
function TextArea(config = {}) {
  return { type: TextAreaControlType, config, version: 1 };
}
export {
  TextArea,
  TextAreaControlDataTypeKey,
  TextAreaControlDataTypeValueV1,
  TextAreaControlType
};
//# sourceMappingURL=text-area.js.map